import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { MaterialListRowDto } from '@models/material-list-row-dto.interface';
import { MaterialDetailDto } from '@models/material-detail-dto.interface';
import { MaterialForEditDto } from '@models/material-for-edit-dto.interface';
import { MaterialLookupsDto } from '@models/material-lookups-dto.interface';
import { CisProLookupDto } from '@models/cis-pro-lookup-dto.interface';
import { SaveMaterialDto } from '@models/save-material-dto.interface';
import { MaterialListQuery } from '@models/material-list-query.interface';
import { BulkDeleteMaterialsDto } from '@models/bulk-delete-materials-dto.interface';
import { PagedResult } from '@shared/models/paged-result.model';
import { SearchParameters } from '@shared/models/search-parameters.model';

@Injectable({
  providedIn: 'root',
})
export class MaterialsService {
  private readonly apiService = inject(ApiService);

  searchMaterials(
    searchParameters: SearchParameters<MaterialListQuery>
  ): Observable<PagedResult<MaterialListRowDto>> {
    const request: SearchParameters<MaterialListQuery> = {
      ...searchParameters,
      query: {
        ...searchParameters.query,
        filter: searchParameters.query.filter?.trim() || null,
      },
    };
    return this.apiService.post('materials/search', request);
  }

  getMaterial(id: number): Observable<MaterialDetailDto> {
    return this.apiService.get(`materials/${id}`);
  }

  getMaterialForEdit(id: number): Observable<MaterialForEditDto> {
    return this.apiService.get(`materials/${id}/edit`);
  }

  getLookups(rigId?: number): Observable<MaterialLookupsDto> {
    const query = rigId == null ? '' : `?rigId=${rigId}`;
    return this.apiService.get(`materials/lookups${query}`);
  }

  getCisProByBarcode(barcode: string): Observable<CisProLookupDto> {
    return this.apiService.get(`materials/cispro/${encodeURIComponent(barcode)}`);
  }

  createMaterial(dto: SaveMaterialDto): Observable<number> {
    return this.apiService.post('materials', dto);
  }

  updateMaterial(id: number, dto: SaveMaterialDto): Observable<void> {
    return this.apiService.put(`materials/${id}`, dto);
  }

  deleteMaterial(id: number): Observable<void> {
    return this.apiService.delete(`materials/${id}`);
  }

  previewBulkDelete(dto: BulkDeleteMaterialsDto): Observable<MaterialListRowDto[]> {
    return this.apiService.post('materials/preview-delete', dto);
  }

  bulkDeleteMaterials(dto: BulkDeleteMaterialsDto): Observable<{ deletedCount: number }> {
    return this.apiService.post('materials/bulk-delete', dto);
  }
}
